"use strict";
exports.__esModule = true;
exports.toBanner = void 0;
var utils_1 = require("@lglp/utils");
var constants_1 = require("../constants");
var fields_1 = require("../fields");
var toBanner = function (data, logger) {
    var prismicBanner = utils_1.unprefix('banner', data);
    if (prismicBanner) {
        return utils_1.compact({
            label: logger.required(fields_1.toText(prismicBanner.title)),
            description: fields_1.toText(prismicBanner.description),
            themeColor: constants_1.toThemeColor(prismicBanner.themeColor, logger)
        });
    }
};
exports.toBanner = toBanner;
//# sourceMappingURL=banner.js.map